module.exports = __webpack_public_path__ + "fonts/IBMPlexMono-Regular.76241523.woff2";